import { Navigate } from 'react-router-dom';
import { useAuth } from './auth-context.js';

const INTERNAL_ROLES = new Set(['ADMIN', 'OPERATOR', 'ACCOUNTANT']);

/**
 * Index-route selector. Internal roles land on the customers list; tier
 * users (Customer / Partner Admin / Order Placer) land on the read-only
 * `/my` home where their scope is acknowledged. Default fallback is the
 * customer list, so a misconfigured user is never silently locked out.
 */
export function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  const firstRole = user?.roles[0]?.role;
  if (firstRole && !INTERNAL_ROLES.has(firstRole)) {
    return <Navigate to="/my" replace />;
  }
  return <Navigate to="/customers" replace />;
}
